import BillsHome from '../../../bills/components/home/BillsHome';

export default function BillsOverviewScreen() {
    return <BillsHome />;
}
